import { render, staticRenderFns } from "./ui-title.vue?vue&type=template&id=17ac0c1d"
import script from "./ui-title.vue?vue&type=script&lang=js"
export * from "./ui-title.vue?vue&type=script&lang=js"
import style0 from "./ui-title.vue?vue&type=style&index=0&id=17ac0c1d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports